import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import { SHOP } from "@/constants/testIds";
import { usePriveProductIds, SET_REQUIREMENT } from "@/lib/community";

export default function Shop() {
  const [params, setParams] = useSearchParams();
  const category = params.get("category") || "";
  const prive = params.get("prive") === "1";
  const priveIds = usePriveProductIds();
  const [allProducts, setProducts] = useState([]);
  const [loadingProducts, setLoading] = useState(true);
  const loading = loadingProducts || (prive && !priveIds);
  const products = prive && priveIds ? allProducts.filter((p) => priveIds.includes(p.id)) : allProducts;

  useEffect(() => {
    setLoading(true);
    const q = category ? `?category=${category}` : "";
    api
      .get(`/products${q}`)
      .then((r) => setProducts(r.data))
      .finally(() => setLoading(false));
  }, [category]);

  const setCat = (c) => {
    if (c) setParams({ category: c });
    else setParams({});
  };

  const chip = (active) =>
    `px-5 py-2 rounded-full text-sm tracking-wide transition-all duration-300 border ${
      active
        ? "bg-[#1A1C1A] text-[#F9F9F6] border-[#1A1C1A]"
        : "bg-transparent text-[#1A1C1A] border-stone-300 hover:border-[#1A1C1A]"
    }`;

  return (
    <div className="pt-24 md:pt-32">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16">
        <p className="text-xs uppercase tracking-[0.3em] text-stone-500 font-semibold mb-4">The Collection</p>
        <h1 className="font-serif text-5xl sm:text-6xl md:text-7xl font-light tracking-tighter text-[#1A1C1A]">
          {prive && <>Privé <em className="italic text-stone-600">qualifying sets</em>.</>}
          {!prive && category === "gym" && <>Performance <em className="italic text-stone-600">wear</em>.</>}
          {!prive && category === "beauty" && <>Renewal <em className="italic text-stone-600">beauty</em>.</>}
          {!prive && !category && <>Shop the <em className="italic text-stone-600">collective</em>.</>}
        </h1>
        {prive && (
          <p data-testid="shop-prive-note" className="mt-5 max-w-2xl text-stone-600 font-light">{SET_REQUIREMENT}</p>
        )}

        <div className="mt-10 md:mt-14 flex flex-wrap gap-3">
          <button data-testid={SHOP.filterAll} onClick={() => setCat("")} className={chip(!category && !prive)}>
            All
          </button>
          <button data-testid={SHOP.filterGym} onClick={() => setCat("gym")} className={chip(!prive && category === "gym")}>
            Performance
          </button>
          <button data-testid={SHOP.filterBeauty} onClick={() => setCat("beauty")} className={chip(!prive && category === "beauty")}>
            Beauty
          </button>
          <button data-testid="shop-filter-prive" onClick={() => setParams({ prive: "1" })} className={chip(prive)}>
            Privé sets
          </button>
        </div>

        <div className="mt-12 md:mt-16 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 md:gap-10 pb-24 md:pb-32">
          {loading &&
            Array.from({ length: 8 }).map((_, i) => (
              <div key={i} className="aspect-[4/5] bg-[#F4F1EA] rounded-2xl animate-pulse" />
            ))}
          {!loading && products.length === 0 && (
            <p className="col-span-full text-stone-500 font-serif italic text-2xl py-20">Nothing here yet — check back soon.</p>
          )}
          {!loading &&
            products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
      </div>
    </div>
  );
}
